export default __webpack_public_path__ + "61dbb58dd9938ec3b140bbadcc84ad79.svg";